import React from 'react';

import { Button } from 'src/app/components/lib/button';
import { Checkbox } from 'src/app/components/lib/checkbox';
import { Divider } from 'src/app/components/lib/divider';
import { FullWidthWizardCard } from 'src/app/components/lib/wizard/card/full-width-card';

import { AppliedFilters } from '../../shared/applied-filters';
import { FilteredProductCount } from '../../shared/filtered-product-count';
import { RequirementCardWrapper, RequirementCardRow, RequirementCardTitle } from '../../shared/styled';
import { useDiscountWizardStateContext } from '../../state';
import { RewardsStepActions } from '../../state/rewards';

import { ConditionRow } from './condition-row';

type RewardProductsCardProps = {
  onEditFiltersClick: () => void;
};

export function RewardProductsCard({ onEditFiltersClick }: RewardProductsCardProps) {
  const {
    rewardsStepDispatch,
    rewardsStepState: {
      condition: { requireSameProduct, allowNonCannabisItems },
    },
  } = useDiscountWizardStateContext();
  return (
    <FullWidthWizardCard noInfo>
      <RequirementCardWrapper>
        <RequirementCardRow $spaceBetween>
          <RequirementCardTitle>Reward products</RequirementCardTitle>
        </RequirementCardRow>
        <ConditionRow />
        <RequirementCardRow $spaceBetween>
          <div>
            Filters applied: <AppliedFilters requirement='reward' />
          </div>
          <Button buttonSize='small' label='Edit filters' variant='secondary' onClick={onEditFiltersClick} />
        </RequirementCardRow>
        <RequirementCardRow>
          <div>
            Eligible products: <FilteredProductCount requirement='reward' />
          </div>
          <Divider variant='vertical-flex' />
          <div>
            <Checkbox
              checked={requireSameProduct}
              label='Require same product'
              labelPlacement='end'
              tooltip='Requires that all rewards are the same product.'
              useV2Tooltip
              onChange={({ target }) =>
                rewardsStepDispatch({ type: RewardsStepActions.SET_REQUIRE_SAME_PRODUCT, payload: target.checked })
              }
            />
          </div>
          <Divider variant='vertical-flex' />
          <div>
            <Checkbox
              checked={allowNonCannabisItems}
              label='Include non-cannabis items'
              labelPlacement='end'
              onChange={({ target }) =>
                rewardsStepDispatch({ type: RewardsStepActions.SET_ALLOW_NON_CANNABIS_ITEMS, payload: target.checked })
              }
            />
          </div>
        </RequirementCardRow>
      </RequirementCardWrapper>
    </FullWidthWizardCard>
  );
}
